import { qprConstants } from '../Constants'
const qprDataReducer = (state = {}, action) => {
  switch (action.type) {
    case qprConstants.QPR_DATA_SUCCESS:
      return action.payload;
    case qprConstants.QPR_DATA_FAILURE:
      return {};
    default:
      return state;
  }
}

export default qprDataReducer;